<template>
  <div class="home-page" :style="{ paddingBottom: `${basePaddingBottom + paddHeight}px` }">
    <div class="hero-section">
      <div class="hero-top">
        <div class="hero-copy">
          <div class="hero-title">
            <img class="hero-title-logo" src="../assets/LOGO.jpg" alt="logo">
            <span>鹊桥会</span>
          </div>
          <div class="hero-desc">{{ COMPANYNAME }}企业内部婚恋交友平台</div>
        </div>
        <button class="sign-out" @click="handleSignOut">
          <img src="../assets/btn_sign out@2x.png" alt="">
          <span>退出</span>
        </button>
      </div>

      <div class="status-card">
        <div class="status-item">
          <span class="status-label">当前身份</span>
          <span class="status-value">{{ roleText }}</span>
        </div>
        <div class="status-item">
          <span class="status-label">审核状态</span>
          <span class="status-value" :class="{ pending: !!nextRoleText }">
            {{ nextRoleText || "暂无待审核申请" }}
          </span>
        </div>
      </div>
    </div>

    <div class="banner-card">
      <van-swipe v-if="images.length > 0" :autoplay="3000" lazy-render>
        <van-swipe-item v-for="(image, index) in images" :key="index">
          <img :src="image.url" alt="">
        </van-swipe-item>
      </van-swipe>
      <div v-else class="banner-empty">
        <img class="empty-icon" src="../assets/LOGO.jpg" alt="logo">
        <div class="empty-title">缘分上新中</div>
        <div class="empty-desc">精彩活动、会员与红娘内容会展示在这里</div>
      </div>
    </div>

    <div class="section-head">
      <div>
        <div class="section-title">快捷入口</div>
        <div class="section-desc">一键跳转，快速直达</div>
      </div>
    </div>

    <div class="quick-grid">
      <div class="quick-card" @click="$router.push({ path: '/detail' })">
        <div class="quick-icon-wrap">
          <img src="../assets/btn_Magpie Bridge Club@2x.png" alt="">
        </div>
        <div class="quick-title">鹊桥会</div>
        <div class="quick-desc">了解平台介绍与服务内容</div>
      </div>

      <div class="quick-card" @click="joinMember">
        <div class="quick-icon-wrap">
          <img src="../assets/btn_join Magpie Bridge Club@2x.png" alt="">
        </div>
        <div class="quick-title">成为会员</div>
        <div class="quick-desc">提交资料后进入会员中心</div>
      </div>

      <div class="quick-card" @click="$router.push({ path: '/matchmakerGroup' })">
        <div class="quick-icon-wrap">
          <img src="../assets/btn_Matchmaker@2x.png" alt="">
        </div>
        <div class="quick-title">红娘团队</div>
        <div class="quick-desc">查看平台红娘与团队介绍</div>
      </div>

      <div class="quick-card" :class="{ muted: disabled }" @click="joinMatchmaker">
        <div class="quick-icon-wrap">
          <img src="../assets/btn_join Matchmaker@2x.png" alt="">
        </div>
        <div class="quick-title">加入红娘</div>
        <div class="quick-desc">{{ disabled ? "当前账号暂不支持申请" : "提交资料成为平台红娘" }}</div>
      </div>
    </div>

    <TabBar active-key="home" />
  </div>
</template>
<script>
import TabBar from "@/components/TabBar.vue";
import { getOaInfo } from "@/utils/auth";
import { navigateToJoinMember } from "@/utils/memberEntry";
import { Toast, Dialog } from "vant";
import { mapGetters } from "vuex";
import { getDefaultCoverInfo } from "../api/user";

export default {
  components: { TabBar },
  data() {
    return {
      COMPANYNAME: process.env.COMPANYNAME,
      images: [],
      paddHeight: 0,
      disabled: false,
      basePaddingBottom: 96
    };
  },
  computed: {
    ...mapGetters(["role", "nextRole", "baseInfo"]),
    roleText() {
      const roleMap = {
        Matchmaker: "红娘",
        Member: "会员",
        GeneralUser: "普通用户"
      };
      return roleMap[this.role] || "未加入";
    },
    nextRoleText() {
      const roleMap = {
        Matchmaker: "红娘申请审核中",
        Member: "会员申请审核中"
      };
      return roleMap[this.nextRole] || "";
    }
  },
  methods: {
    joinMember() {
      navigateToJoinMember({
        role: this.$store.getters.role,
        nextRole: this.$store.getters.nextRole,
        router: this.$router,
        toast: message => Toast.fail({ message })
      });
    },
    joinMatchmaker() {
      const role = this.$store.getters.role;
      const nextRole = this.$store.getters.nextRole;
      if (role === "Matchmaker") {
        Toast.fail({
          message: "您已加入红娘"
        });
        return;
      }
      if (role === "Member") {
        Toast.fail({
          message: "您已加入会员，为了保证身份唯一性，不可再加入红娘"
        });
        return;
      }
      if (nextRole === "Matchmaker") {
        Toast.fail({
          message: "您已申请加入红娘,目前正在审核中。"
        });
        return;
      }
      if (nextRole === "Member") {
        Toast.fail({
          message: "您已申请加入会员,目前正在审核中。"
        });
        return;
      }
      this.$router.push({ path: "/joinMatchMaker" });
    },
    handleSignOut() {
      this.$store.dispatch("RemoveToken");
      if (location.href.indexOf("?") !== -1) {
        window.location.replace("/mbc/index.html#/");
      } else {
        this.$router.push({ path: "/login" });
      }
    }
  },
  mounted() {
    if (document.body.clientHeight) {
      let height = document.body.clientHeight;
      const showHeight =
        getComputedStyle(window.document.documentElement)["font-size"].slice(0, -2) * 32.56;
      if (height < showHeight) {
        this.paddHeight = showHeight - height + 10;
      } else {
        this.paddHeight = 0;
      }
    }
  },
  created() {
    getDefaultCoverInfo().then(res => {
      if (res.code === 20000) {
        this.images = res.data || [];
      }
    });
    let data = getOaInfo();
    if (data && data.employeeSubGroup === "一级员工") {
      this.disabled = true;
    }
    // 无头像用户提示上传
    if (this.role === "Member" && this.baseInfo && !this.baseInfo.avatarLink) {
      Dialog.confirm({
        title: "温馨提示",
        message: "您还未上传头像，上传头像后更容易被推荐哦~",
        confirmButtonText: "去上传",
        cancelButtonText: "稍后"
      }).then(() => {
        this.$router.push({ path: "/editInfos" });
      }).catch(() => {});
    }
  }
};
</script>
<style src="../style/homePage.less" scoped lang="less" />



// WEBPACK FOOTER //
// src/views/homePage.vue